import styled from 'styled-components';

interface ContentProps {
  $variant: 'contained' | 'outlined' | 'transparent',
  $padding: 'none' | 'small' | 'medium' | 'large',
  $maxWidth?: number,
  $fillHeight?: boolean,
}

const getPadding = (padding: ContentProps['$padding']) => {
  switch (padding) {
    case 'none':
      return 0;
    case 'small':
      return 1;
    case 'medium':
      return 2;
    case 'large':
      return 3;
    default:
      return 2;
  }
};

const Content = styled.div`
`;

const CardContainer = styled.div<ContentProps>`
  width: 100%;
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'none')};
  display: flex;
  justify-content: flex-start;
  padding: ${({ theme, $padding }) => `${theme.spacing(1.5 * getPadding($padding))} ${theme.spacing(2 * getPadding($padding))}`};
  flex-direction: column;
  position: relative; 
  background-color: ${({ theme, $variant }) => ($variant === 'contained' ? theme.palette.backdrop.main : 'none')};
  border: ${({ theme, $variant }) => ($variant === 'outlined' ? `1.5px solid ${theme.palette.backdrop.main}` : 'none')};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 3}px;
  height: ${({ $fillHeight }) => ($fillHeight ? '100%' : 'auto')};
`;

export { Content, CardContainer };
